export default "__VITE_ASSET__BXbJNdYe__"